import { getUtcDate } from './get-utc-date';

export function getUtcYesterday(): Date {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  return getUtcDate(yesterday);
}
